export const _topicType = ['立即提问', '发布主题'];
